var init = function () {
    //获取当前html的宽度
    var clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
    //移动端宽度如果超过750就按照750来算
    if (clientWidth >= 750&&clientWidth<1000) {
        clientWidth = 750;
    }
    //移动端宽度如果超过750就按照850来算
    if (clientWidth >= 1000) {
        clientWidth = 500;
        }

    //得到对应比例的fontsize，这样一个rem就是20px了
    var fontSize = 20 / 375 * clientWidth;
    document.documentElement.style.fontSize = fontSize + "px";
}
init();
window.addEventListener("resize", init);